import React from "react";

interface SmallStatusBadgeProps {
    label?: string;
}

/**
 * The colours the URS requirement table has always used for these three states. Exported so the
 * snapshot comparison can paint its own badges from the same values instead of copying them and
 * drifting the next time one is adjusted.
 */
export const statusStyles: Record<string, React.CSSProperties> = {
    DELETED: {
        backgroundColor: '#fecaca',
        color: '#991b1b',
    },
    MODIFIED: {
        backgroundColor: '#bfdbfe',
        color: '#1e40af',
    },
    ADDED: {
        backgroundColor: '#bbf7d0',
        color: '#166534',
    },
}

const SmallStatusBadge: React.FC<SmallStatusBadgeProps> = ({ label }) => {
    if (!label) return null;

    const normalizedLabel = label.toUpperCase()
    const statusStyle = statusStyles[normalizedLabel]

    if (!statusStyle) return null;

    return (
        <span
            style={{
                ...statusStyle,
                marginLeft: '0.25rem',
                padding: '0.125rem 0.25rem',
                borderRadius: '0.25rem',
                fontWeight: 600,
                fontSize: '0.7rem',
                lineHeight: 1.2,
                position: 'relative',
                top: '-5px',
                display: 'inline-block',
            }}
        >
            {normalizedLabel}
        </span>
    );
};

export default SmallStatusBadge;
